import { cloneElement, ReactElement, ReactPortal, useState } from 'react'
import BigNumber from 'bignumber.js'
import styled from 'styled-components'
import { useTranslation } from 'contexts/Localization'
import { Flex, CardFooter, ExpandableLabel, HelpIcon, useTooltip, Tag, RefreshIcon } from '@pancakeswap/uikit'
import { DeserializedPool } from 'state/types'
import { CompoundingPoolTag, ManualPoolTag } from 'components/Tags'
import ExpandedFooter from './ExpandedFooter'

interface FooterProps {
  pool: DeserializedPool
  account: string
  totalCakeInVault?: BigNumber
  defaultExpanded?: boolean
}

const ExpandableButtonWrapper = styled(Flex)`
  align-items: center;
  justify-content: space-between;
  button {
    padding: 0;
  }
`

const Footer: React.FC<FooterProps> = ({ pool, account, defaultExpanded }) => {
  const { vaultKey } = pool
  const { t } = useTranslation()
  const [isExpanded, setIsExpanded] = useState(defaultExpanded || false)

  const manualTooltipText =
    pool.sousId == 56
      ? t(`Stake your HODL Hands NFTs to earn $HODL rewards.
This pool holds up to 1,000 NFTs in total, with a maximum of 20 NFTs per wallet.
A total of 5,000,000 $HODL is allocated to this pool.
Rewards run for 45 days from 1 April at 12:00 UTC.
You can unstake at any time.`)
      : pool.isNft
      ? pool.stakingToken.name === 'HODL Hands® NFTs'
        ? pool.withdrawFee !== true
          ? t(
              `Stake your HODL Hands® NFTs to earn ${pool.earningToken.symbol} tokens at the displayed APR. Grow your rewards by joining the pool now!

            There are no fees to stake and you can withdraw at any time!`,
            )
          : t(
              `Stake your HODL Hands® NFTs to earn ${pool.earningToken.symbol} tokens at the displayed APR. Grow your rewards by joining the pool now!`,
            )
        : t(
            'The price of each NFT is based on the live $ price of each NFT to mint, minus the discount. This is then converted into how many tokens that is worth.  There are no taxes on swapping tokens for NFTs and the tokens are sent to the deployer or to specialist pools for investors to earn!',
          )
      : t('To claim your NFTs you must ‘Harvest’ and you can topup in BNB on any partially earned NFTs!', {
          symbol: pool.stakingToken.symbol,
        })
  const autoTooltipText = t(
    'Any funds you stake in this pool will be automagically harvested and restaked (compounded) for you.',
  )

  const { targetRef, tooltip, tooltipVisible } = useTooltip(vaultKey ? autoTooltipText : manualTooltipText, {
    placement: 'bottom',
  })

  return (
    <CardFooter>
      <ExpandableButtonWrapper>
        <Flex alignItems="center">
          {/* {vaultKey ? <CompoundingPoolTag /> : <ManualPoolTag />} */}
          {/* <Tag variant="secondary" outline startIcon={<RefreshIcon width="18px" color="secondary" mr="4px" />}>
            {t('How does it work?')}
          </Tag> */}
          <Tag variant="secondary" outline>
            {t('How it works?')}
          </Tag>
          {tooltipVisible && tooltip}
          <Flex ref={targetRef}>
            <HelpIcon ml="4px" width="20px" height="20px" color="textSubtle" />
          </Flex>
        </Flex>
        <ExpandableLabel expanded={isExpanded} onClick={() => setIsExpanded(!isExpanded)}>
          {isExpanded ? t('Collapse') : t('Details')}
        </ExpandableLabel>
      </ExpandableButtonWrapper>
      {isExpanded && <ExpandedFooter pool={pool} account={account} />}
    </CardFooter>
  )
}

export default Footer
